import React from "react";
import {DashboardBrokerUsage} from "../../types/DashboardBrokerUsage";

interface BrokerUsageRowProps {
    brokerUsage: DashboardBrokerUsage;
}

const HIGH_ALLOCATION_THRESHOLD = 0.8;

export let BrokerUsageRow = function (props: BrokerUsageRowProps) {
    let brokerUsage = props.brokerUsage;
    let isUnlimited = brokerUsage.unlimited_trucks;
    let proportion = brokerUsage.total_truck_count > 0 ? brokerUsage.assigned_truck_count / brokerUsage.total_truck_count : 0;
    let isFullyAllocated = !isUnlimited && brokerUsage.assigned_truck_count >= brokerUsage.total_truck_count;
    let colorModifier = !isUnlimited && proportion >= HIGH_ALLOCATION_THRESHOLD ? 'red' : 'green';
    let fillWidth = isUnlimited ? '100%' : `${Math.min(proportion, 1) * 100}%`;
    return (
        <div className="broker-usage-row" data-broker-id={brokerUsage.broker_id}>
            <div className="broker-usage-row-name">{brokerUsage.broker_name}</div>
            <div className="broker-usage-row-allocation-bar">
                <div className={`broker-usage-row-allocation-bar-track ${colorModifier}`}>
                    <div className={`broker-usage-row-allocation-bar-fill ${colorModifier}`} style={{width: fillWidth}}/>
                </div>
            </div>
            <div className="broker-usage-row-count">
                {`${brokerUsage.assigned_truck_count}/`}
                {isUnlimited
                    ? <img className="broker-usage-row-unlimited-icon" src="/static/images/infinity-textcolor.svg" alt="Unlimited"/>
                    : brokerUsage.total_truck_count}
                {isFullyAllocated && (
                    <img
                        className="broker-usage-row-warning-icon"
                        src="/static/images/warning-triangle-red.svg"
                        alt="Fully allocated"
                    />
                )}
            </div>
        </div>
    );
};
